import { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { useToaster, Notification, Button, Message } from "rsuite";
export default function LoginForm({ site }) {
  const toaster = useToaster();
  const [step, setStep] = useState("credentials");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailOtp, setEmailOtp] = useState("");
  const [mobileOtp, setMobileOtp] = useState("");
  const LOGIN_URL = "https://api.dahiyainsurance.com/Login.php";
  const OTP_URL = "https://api.dahiyainsurance.com/VerifyOTP.php";
  const [errMsg, setErrMsg] = useState("");
  const [ip, setIP] = useState("");
  const [loading, setLoading] = useState(false);
  const userRef = useRef();
  const errRef = useRef();
  useEffect(() => {
    let ismounted = true;
    if (ismounted) userRef.current.focus();
    axios
      .get("https://ip.nf/me.json")
      .then((a) => setIP(ip?.ip))
      .catch((e) => {
        console.log(e);
      });
    return () => {
      ismounted = false;
    };
  }, []);
  const handleLogin = async (e) => {
    e.preventDefault();
    if (email && password) {
      if (site === "GIC") {
        try {
          const response = await axios.post(
            LOGIN_URL,
            JSON.stringify({ Email: email, Password: password }),
            {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            }
          );

          const result = response.data;
          if (
            response &&
            (response["status"] === 201 || response["status"] === 200)
          ) {
            if (result.status === 1) {
              setStep("otp");
            }
            if (result.status === 0) {
              toaster.push(
                <Notification type="error" header="Error">
                  {result.Error}
                </Notification>,
                { placement: "topEnd" },
                { duration: 1000 }
              );
            }
            if (result.status === 2) {
              toaster.push(
                <Notification type="error" header="Error">
                  No access, please contact admin.
                </Notification>,
                { placement: "topEnd" },
                { duration: 1000 }
              );
            }
            if (result.status === 3) {
              toaster.push(
                <Notification type="error" header="Error">
                  Account locked, please contact admin.
                </Notification>,
                { placement: "topEnd" },
                { duration: 1000 }
              );
            }
            // console.log(JSON.stringify(response?.data));
            //console.log(JSON.stringify(response));

            //navigate("/", { replace: true });
            //console.log(response);
          }
        } catch (err) {
          console.log(err);
          if (!err?.response) {
            setErrMsg("No Server Response");
          } else if (err.response?.status === 400) {
            setErrMsg("Missing Username or Password");
          } else if (err.response?.status === 401) {
            setErrMsg("Unauthorized");
          } else {
            setErrMsg("Login Failed");
          }
          errRef.current.focus();
        }
      } else {
        try {
          const response = await axios.post(
            "https://backend.dahiyainsurance.com/Login.php",
            { Email: email, Password: password }
          );
          const result = response.data;
          if (
            response &&
            (response["status"] === 201 || response["status"] === 200)
          ) {
            if (result.status === 1) {
              setStep("otp");
            }
            if (result.status === 0) {
              toaster.push(
                <Notification type="error" header="Error">
                  {result.Error}
                </Notification>,
                { placement: "topEnd" },
                { duration: 1000 }
              );
            }
            if (result.status === 2) {
              toaster.push(
                <Notification type="error" header="Error">
                  No access, please contact admin.
                </Notification>,
                { placement: "topEnd" },
                { duration: 1000 }
              );
            }
            if (result.status === 3) {
              toaster.push(
                <Notification type="error" header="Error">
                  Account locked, please contact admin.
                </Notification>,
                { placement: "topEnd" },
                { duration: 1000 }
              );
            }
            // console.log(JSON.stringify(response?.data));
            //console.log(JSON.stringify(response));

            //navigate("/", { replace: true });
            //console.log(response);
          }
        } catch (err) {
          console.log(err);
          if (!err?.response) {
            setErrMsg("No Server Response");
          } else if (err.response?.status === 400) {
            setErrMsg("Missing Username or Password");
          } else if (err.response?.status === 401) {
            setErrMsg("Unauthorized");
          } else {
            setErrMsg("Login Failed");
          }
          errRef.current.focus();
        }
      }
    } else {
      setErrMsg("Missing Email or Password");
    }

    // Mock API call for email+password authentication
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (site === "GIC") {
      try {
        const response = await axios.post(
          OTP_URL,
          JSON.stringify({
            Email: email,
            Password: password,
            OTP: emailOtp,
          }),
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );

        const result = response.data;
        // console.log(result);
        if (result.status === 1) {
          setEmail("");
          setPassword("");
          setEmailOtp("");
          setMobileOtp("");
          // setPersist(dispatch, true);
          //navigate("/dashboard", { replace: true });
          //console.log("Enter OTP");
          setErrMsg("");
          const token = result.Secure;
          console.log(token);
          const redirectUrl = `https://gic.dahiyainsurance.com/?token=${token}`;
          window.location.href = redirectUrl; // redirect to another website
        }
        if (result.status === 4) {
          toaster.push(
            <Notification type="error" header="Error">
              {`Incorrect OTP, please verify again.`}
            </Notification>,
            { placement: "topEnd" },
            { duration: 1000 }
          );
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      try {
        const response = await axios.post(
          "https://backend.dahiyainsurance.com/VerifyOTP.php",
          { Email: email, Password: password, OTP: emailOtp }
        );
        const result = response.data;
        // console.log(result);
        if (result.status === 1) {
          setEmail("");
          setPassword("");
          setEmailOtp("");
          setMobileOtp("");
          // setPersist(dispatch, true);
          //navigate("/dashboard", { replace: true });
          //console.log("Enter OTP");
          setErrMsg("");
          const token = result.Secure;
          // console.log(token);
          const redirectUrl = `https://lic.dahiyainsurance.com/?token=${token}`;
          window.location.href = redirectUrl; // redirect to another website
        }
        if (result.status === 4) {
          toaster.push(
            <Notification type="error" header="Error">
              {`Incorrect OTP, please verify again.`}
            </Notification>,
            { placement: "topEnd" },
            { duration: 1000 }
          );
        }
      } catch (e) {
        console.log(e);
      }
    }
    // For demo: both OTPs must be "123456"
    /* if (emailOtp === "123456" && mobileOtp === "654321") {
      const fakeToken = `${site}-token-${Date.now()}`;
      const redirectUrl = `https://anotherwebsite.com?token=${fakeToken}`;
      window.location.href = redirectUrl; // redirect to another website
    } else {
      alert("Invalid OTPs");
    } */
  };

  async function resetEmailGIC(email) {
    try {
      const result = await axios.post(
        "https://api.dahiyainsurance.com/resetemail.php",
        { email }
      );
      //console.log(result.data.status);
      if (result.status === 200 && result.data.status === 1) {
        toaster.push(
          <Notification type="success" header="Success">
            Password reset email has been sent. Please check your inbox.
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
      } else {
        toaster.push(
          <Notification type="error" header="Error">
            {`Failed to send email for password reset.`}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
      }
    } catch (error) {
      console.error("Error setting email in:", error);
      // console.log("Email set in localStorage:", email);
    }
  }

  async function resetEmailLIC(email) {
    try {
      const result = await axios.post(
        "https://backend.dahiyainsurance.com/resetemail.php",
        { email }
      );
      console.log(result.data.status);
      if (result.status === 200 && result.data.status === 1) {
        window.confirm(
          `Password reset email has been sent. Please check your inbox.`
        );
      } else {
        window.confirm(`Error! Failed to send email for password reset.`);
      }
    } catch (error) {
      console.error("Error setting email in:", error);
      // console.log("Email set in localStorage:", email);
    }
  }

  function handleForgotPassword(e) {
    e.preventDefault();
    if (email) {
      if (site === "GIC") {
        resetEmailGIC(email);
      } else {
        resetEmailLIC(email);
      }
    } else {
      setErrMsg("Missing Email");
    }
  }

  return (
    <form
      onSubmit={step === "credentials" ? handleLogin : handleVerifyOtp}
      className="space-y-6"
    >
      {/* Email */}
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <label className="block text-sm font-semibold text-gray-600">
          Email Address
        </label>
        <input
          type="email"
          value={email}
          ref={userRef}
          disabled={step === "otp"}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-2 w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
          placeholder="you@example.com"
          required
        />
      </motion.div>

      {/* Password */}
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.1 }}
      >
        <label className="block text-sm font-semibold text-gray-600">
          Password
        </label>
        <input
          type="password"
          value={password}
          disabled={step === "otp"}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-2 w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
          placeholder="••••••••"
          required
        />
      </motion.div>

      {/* OTPs */}
      {step === "otp" && (
        <>
          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.2 }}
          >
            <label className="block text-sm font-semibold text-gray-600">
              Email/Mobile OTP
            </label>
            <input
              type="text"
              value={emailOtp}
              onChange={(e) => setEmailOtp(e.target.value)}
              className="mt-2 w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500"
              placeholder="Enter Email OTP"
              required
            />
          </motion.div>
        </>
      )}

      {/* Button */}
      <motion.button
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.97 }}
        type="submit"
        className="w-full py-3 px-4 bg-blue-600 text-white font-semibold rounded-xl shadow-md hover:bg-blue-700 transition-all"
      >
        {step === "credentials" ? "Login" : "Verify OTP"}
      </motion.button>

      {/* Extra Link */}
      {step === "credentials" && (
        <p className="text-sm text-center text-gray-500 mt-4">
          Forgot password?{" "}
          <a
            href="#"
            className="text-blue-600 hover:underline"
            onClick={handleForgotPassword}
          >
            Reset here
          </a>
        </p>
      )}
    </form>
  );
}
